import { request } from "./request.js";

export function urlText(){
    let a = document.createElement('a')
    if (process.env.NODE_ENV === 'development') {
        a.setAttribute('href','http://localhost:8002/dgut/authorize?state=h5')
    } else {
        a.setAttribute('href','https://txl.dgut.edu.cn/dgut/')
    }
    a.setAttribute('rel', 'noopener noreferrer')
    a.setAttribute('id', 'startTelMedicine')
    // 防止反复添加
    if (document.getElementById('startTelMedicine')) {
        document.body.removeChild(document.getElementById('startTelMedicine'))
    }////
    document.body.appendChild(a)
    a.click()

}
//退出登录
export function logout_url(){

    let a = document.createElement('a')
    a.setAttribute('href','https://auth.dgut.edu.cn/authserver/logout?service=https%3A%2F%2Ftxl.dgut.edu.cn')
    a.setAttribute('rel', 'noopener noreferrer')
    a.setAttribute('id', 'startTelMedicine')
    // 防止反复添加
    if (document.getElementById('startTelMedicine')) {
        document.body.removeChild(document.getElementById('startTelMedicine'))
    }////
    document.body.appendChild(a)
    a.click()

}

export function MessageInfo() {
  return request({
    url: '/getInfo',
    method: 'get'
  })
}

//获取用户详细信息
export function  GetInfo(data) {
    return request({
      url: '/system/user/details/'+data,
      method:'get',

    })
  }

//获取用户列表
export function  UserList(data) {
    return request({
      url:'/system/user/query',
      method:'get',
      params: data
    })
  }

//修改用户列表
export function  update(data) {
  return request({
    url:'/system/user/update',
    method:'put',
    data: data
  })
}


//退出登录
  export function  logout(data) {
      return request({
        url:'/logout',
        method:'get',
        params: data
      })
    }

// 登录方法
export function login(data) {
    return request({
        url: '/apiLogin',
        method: 'post',
        data: data
    })
}


